import { render, staticRenderFns } from "./WebsiteGoodsEdit.vue?vue&type=template&id=c22b852a&scoped=true&"
import script from "./WebsiteGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22b852a",
  null
  
)

export default component.exports